import * as React from "react";

import PropTypes from "prop-types";
import { Modal, Button, Icon } from "semantic-ui-react";
import InputComponent from "../../InputComponent";
import styles from "./AddShopResourceModal.module.css";
import { FaFileUpload, FaSpinner } from "react-icons/fa";
import { uploadResourceShop } from "../../../api/requests";
import ReactQuill from "react-quill";

const { useState, useRef, useCallback, useReducer } = React;

const reducer = (state, action) => {
  switch (action.type) {
    case "CHANGE": {
      const updatedInput = {
        ...state.input,
        [action.field]: action.value,
      };

      const updatedValidation = {
        ...state.validation,
        [action.field]: action.valid,
      };

      const validation = Object.values(updatedValidation).every(Boolean);

      return {
        input: updatedInput,
        validation: updatedValidation,
        fieldsValidation: validation,
      };
    }
  }
};

function AddShopResourceModal({ visibility, onOpenModal, onCloseModal }) {
  const [loading, setLoading] = useState(false);

  const inputRef = useRef();

  const [fieldsChecked, setFieldsChecked] = useState(false);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "string"],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["link", "image"],
    ],
  };

  const initialState = {
    input: {
      base64Image: "",
      productName: "",
      productDescription: "",
      productPrice: "",
      productLink: "",
    },
    validation: {
      base64Image: false,
      productName: false,
      productDescription: false,
      productPrice: false,
      productLink: false,
    },
    fieldsValidation: false,
  };

  const [fieldsState, fieldsDispatch] = useReducer(reducer, initialState);

  const changeInputDispatch = useCallback((field, value) => {
    let valid = false;
    let rvalue = value;
    if (value.length > 0) {
      if (field === "productDescription") {
        if (value.trim() === "<p><br></p>") {
          valid = false;
          rvalue = "";
        } else {
          valid = true;
        }
      } else {
        valid = true;
      }
    }

    const action = {
      type: "CHANGE",
      field,
      value: rvalue,
      valid,
    };

    fieldsDispatch(action);
  }, []);

  const onSaveResource = async () => {
    setFieldsChecked(true);

    if (!fieldsState.fieldsValidation) {
      return;
    }

    try {
      setLoading(true);
      const response = await uploadResourceShop({ ...fieldsState.input });

      if (response) {
        onCloseModal();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const onSelectResource = (event) => {
    try {
      const files = event.target.files;

      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onload = (e) =>
        changeInputDispatch("base64Image", e.target.result);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      size="large"
      centered
      open={visibility}
      onOpen={onOpenModal}
      onClose={onCloseModal}
    >
      <div className={`${styles.modalContainer} flex flex-col`}>
        <Button
          className={styles.closeButton}
          onClick={onCloseModal}
          size="big"
          icon="close"
        />
        <text className={`${styles.headerText} block mb-2.5`}>
          Add shop resource
        </text>
        <text className={`${styles.subText} block mb-20`}>
          Add details below to link to the Holistic Management & Consultancy
          website shop
        </text>

        <div className={`${styles.Container}`}>
          <div>
            <input
              ref={inputRef}
              onChange={onSelectResource}
              type="file"
              accept={`image/jpeg, image/jpg`}
              style={{ display: "none" }}
            />

            <span className={`${styles.uploadResourceTitle} block mb-2.5`}>
              Upload feature image (JPG 600x400px)
            </span>

            <div
              onClick={() => inputRef.current.click()}
              className={`${styles.uploadResourcePlaceholder} text-center py-5`}
            >
              {fieldsState.input.base64Image ? (
                <div className={`w-full flex justify-center items-center`}>
                  <img
                    className={`bg-cover bg-center h-72 w-auto`}
                    src={fieldsState.input.base64Image}
                  />
                </div>
              ) : (
                <div>
                  <Icon className={styles.uploadResourceIcon} name="arrow up" />

                  <text
                    className={`${styles.uploadResourceIconText} block mt-5`}
                  >
                    Upload feature image
                  </text>
                </div>
              )}
            </div>
            {fieldsChecked && !fieldsState.validation.base64Image && (
              <div className={`text-red-400 p-2 font-thin italic`}>
                This field is required.
              </div>
            )}
          </div>

          <InputComponent
            fieldName="productName"
            type="text"
            label="Product name"
            placeholder="Product name"
            required={true}
            showNotFilled={fieldsChecked && !fieldsState.validation.productName}
            setInputValue={changeInputDispatch}
          />
          <div>
            <h4
              className={`pb-2`}
              style={{ fontSize: "20px", lineHeight: "28px" }}
            >
              Product description<span className={`text-red-400 `}>*</span>
            </h4>
            <div className={`h-64 pb-14 `}>
              <ReactQuill
                className={`h-full `}
                modules={modules}
                value={fieldsState.input.productDescription}
                onChange={(value) =>
                  changeInputDispatch("productDescription", value)
                }
              />
              <textarea
                className={`hidden`}
                value={fieldsState.input.productDescription}
                onChange={() => null}
              />
            </div>
            {fieldsChecked && !fieldsState.validation.productName && (
              <div className={`text-red-400 p-2 font-thin italic `}>
                This field is required.
              </div>
            )}
          </div>

          <InputComponent
            fieldName="productPrice"
            type="text"
            label="Product price"
            placeholder="Product price"
            required={true}
            showNotFilled={
              fieldsChecked && !fieldsState.validation.productPrice
            }
            setInputValue={changeInputDispatch}
          />

          <InputComponent
            fieldName="productLink"
            type="text"
            label="Product link "
            placeholder="Product link"
            required={true}
            showNotFilled={fieldsChecked && !fieldsState.validation.productLink}
            setInputValue={changeInputDispatch}
          />

          <div className={`text-center mt-11`}>
            <button
              disabled={loading}
              onClick={onSaveResource}
              className={`${styles.saveButton}`}
            >
              {loading ? (
                <div className={`flex justify-center items-center`}>
                  {" "}
                  <FaSpinner className={`animate-spin`} />{" "}
                  <span className={`ml-2`}>Saving...</span>{" "}
                </div>
              ) : (
                `Save resource`
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

AddShopResourceModal.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default AddShopResourceModal;
